import { CheckCircleFilled, ExclamationCircleFilled } from "@ant-design/icons"
import { Visit } from "interface/visit"
import { Configuration } from "modules/footprint/Configuration"
import { useFootprint } from "modules/footprint/useFootprint"
import { useEffect } from "react"
import { usePatientDevice } from "services/patients"
import { useStepCompletion } from "./useStepCompletion"

export function StepUpdateFootprint({ visit }: { visit: Visit }) {
	const footprint = useFootprint()
	const {
		data: patientDevice,
		isSuccess,
		isError,
		refetch,
	} = usePatientDevice(visit.patient?.id!, ["isUpToDate"])
	const { markStepAs, softwareUpdate } = useStepCompletion(visit)

	useEffect(() => {
		if (patientDevice?.isUpToDate && !softwareUpdate) {
			markStepAs("softwareUpdate")
		}
	}, [markStepAs, patientDevice?.isUpToDate, softwareUpdate])

	useEffect(() => {
		if (footprint.isUpdateError || footprint.isUpdateSuccess) {
			refetch()
		}
	}, [footprint.isUpdateError, footprint.isUpdateSuccess, refetch])

	return (
		<div className="flex size-full flex-col place-content-center items-center gap-3">
			{patientDevice?.isUpToDate && (
				<>
					<CheckCircleFilled
						aria-hidden
						className="text-[48px] text-green-60"
					/>
					The Footprint is up-to-date
				</>
			)}

			{!patientDevice?.isUpToDate && (
				<div className="flex min-w-full grow flex-col items-center gap-2">
					Update the Footprint to the latest software
					<div className="flex min-w-full shrink-0 grow flex-col items-center gap-1 rounded-lg bg-white p-2">
						{isSuccess && (
							<>
								<ExclamationCircleFilled
									aria-hidden
									className="text-yellow-orange-60"
								/>
								The Footprint's software needs to be updated
							</>
						)}

						{isError && (
							<>
								<ExclamationCircleFilled aria-hidden className="text-red-60" />
								The Footprint is offline
							</>
						)}
					</div>
					<Configuration className="w-full" />
				</div>
			)}
		</div>
	)
}
